<template>
    <div class="developer-index docs-list">
        <div class="doc-body">
            <div class="sidebar">
                <div class="traditional-beacon">
                    <h3>Traditional Beacon</h3>
                    <ul class="nav menu">
                        <li
                            v-for="(item,index) in navBar"
                            :class="item.navClass"
                            :key=index
                            @click="changeBar(index)">
                            <a :href="'#section' + (index+1)">
                                {{item.navItem}}
                            </a>
                        </li>
                    </ul>
                </div>
                <h3 class="alpha-product">
                    <a href="http://docs.sensoro.com/en"> Alpha Product</a>
                </h3>
            </div>

            <div class="content en ">
                <div class="markdown" ref="cBox">
                    <largeScale></largeScale>
                    <ios></ios>
                    <androidEN></androidEN>
                    <restApi></restApi>
                    <privateEN></privateEN>
                    <demo></demo>
                    <config></config>
                    <inspect></inspect>
                    <develop></develop>
                    <cloud></cloud>
                    <hwParams></hwParams>
                    <specification></specification>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import androidEN from '../components/docs/androidEN';
    import cloud from '../components/docs/cloud';
    import config from '../components/docs/config';
    import demo from '../components/docs/demo';
    import develop from '../components/docs/develop';
    import hwParams from '../components/docs/hwParams';
    import inspect from '../components/docs/inspect';
    import ios from '../components/docs/ios';
    import largeScale from '../components/docs/largeScale';
    import privateEN from '../components/docs/privateEN';
    import restApi from '../components/docs/restApi';
    import specification from '../components/docs/specification'

    export default {
        name: "developer",
        data() {
            return {
                navBar: [
                    {
                        navItem: 'Large-Scale',
                        navClass: 'active'
                    },
                    {
                        navItem: 'iOS SDK',
                        navClass: ''
                    },
                    {
                        navItem: 'Android SDK',
                        navClass: ''
                    },
                    {
                        navItem: 'REST API',
                        navClass: ''
                    },
                    {
                        navItem: 'Private Protocol',
                        navClass: ''
                    },
                    {
                        navItem: 'Yunzi App',
                        navClass: ''
                    },
                    {
                        navItem: 'Configuration Tool',
                        navClass: ''
                    },
                    {
                        navItem: 'Inspection Tool',
                        navClass: ''
                    },
                    {
                        navItem: 'Deployment Tool',
                        navClass: ''
                    },
                    {
                        navItem: 'SENSORO Cloud',
                        navClass: ''
                    },
                    {
                        navItem: 'Hardware Params',
                        navClass: ''
                    },
                    {
                        navItem: 'Specification',
                        navClass: ''
                    }
                ]
            }
        },
        created() {
            // this.reSize();
        },
        mounted() {
            var cBox = Array.prototype.slice.call(this.$refs.cBox.children);
            // var cBox = this.cBox;
            var hash = window.location.hash || '';
            if (hash) {
                cBox.filter((item, index) => {
                    var hashNum = Number(hash.substr(8)) - 1;
                    if (index === hashNum) {
                        this.navBar[index].navClass = 'active';
                        item.style.display = 'block';
                    } else {
                        this.navBar[index].navClass = '';
                        item.style.display = "none"
                    }
                })
            }
        },
        methods: {
            changeBar(key) {
                var cBox = Array.prototype.slice.call(this.$refs.cBox.children);
                cBox.filter((item, index) => {
                    if (index === key) {
                        this.navBar[index].navClass = 'active';
                        item.style.display = 'block';
                    } else {
                        this.navBar[index].navClass = '';
                        item.style.display = "none"
                    }
                });
            }
        },
        components: {
            androidEN,
            cloud,
            config,
            demo,
            develop,
            hwParams,
            inspect,
            ios,
            largeScale,
            privateEN,
            restApi,
            specification
        }
    }
</script>

<style lang="less">
    @import "../assets/css/docs";

    .developer-index {
        padding-top: 184px;

        .traditional-beacon .menu {
            border-right: 1px solid #ccc;
        }

        .doc-body {
            width: 1000px;
            margin: 0 auto;
            background: #fff;
            margin-bottom: 60px;

            .content {
                height: 1000px;
                overflow: auto;

                &::-webkit-scrollbar {
                    display: none;
                }
            }
        }

        .markdown {
            font-family: "Helvetica Neue", Helvetica, "Hiragino Sans GB", Arial, sans-serif;
            font-size: 14px;
            line-height: 22px;
            color: #737373;
            background-color: white;
            margin: 10px 13px;
            -webkit-font-smoothing: subpixel-antialiased;

            h1, h2, h3, h4, h5, h6, p, blockquote {
                margin: 0;
                padding: 0;
            }

            h1, h2, h3, h4, h5, h6 {
                color: #404040;
                line-height: 36px;
            }

            h1 {
                margin-bottom: 18px;
                font-size: 30px
            }

            h2 {
                font-size: 24px;
                border: none;
            }

            h3 {
                margin-top: 40px;
                font-size: 20px;
            }

            h4 {
                font-size: 16px;
            }

            h5 {
                font-size: 14px
            }

            h6 {
                font-size: 13px
            }

            hr {
                margin: 0 0 19px;
                border: 0;
                border-bottom: 1px solid #ccc;
                background: none;
            }

            p {
                font-size: 14px;
                line-height: 22px;
                margin-bottom: 9px;
            }

            blockquote {
                padding: 13px 13px 21px 15px;
                margin-bottom: 18px;
                font-family: georgia, serif;
                font-style: italic;

                &:before {
                    content: "\201C";
                    font-size: 40px;
                    margin-left: -10px;
                    font-family: georgia, serif;
                    color: #eee
                }

                p {
                    font-size: 14px;
                    font-weight: 300;
                    line-height: 22px;
                    margin-bottom: 0;
                    font-style: italic
                }
            }

            li {
                a {
                    color: #000;
                }
            }

            table {
                font-size: 14px;
                margin: 10px 0 15px 0;
                border-collapse: collapse;
            }

            td, th {
                font-size: 14px;
                border: 1px solid #ddd;
                padding: 3px 10px;
                background-color: #fff;
                color: #737373;
            }

            th {
                font-size: 14px;
                padding: 5px 10px;
                color: #737373;
            }

            a {
                background-color: #666666;
                color: #ffffff;
                text-decoration: none;
                display: inline-block;
                padding: 0 6px;

                &:hover {
                    background-color: #999999;
                    text-decoration: none;
                }

                img {
                    border: none
                }
            }

            span.n {
                color: white;
                padding: 0px 3px;
                background-color: #404040;
                margin-right: 10px
            }

            article {
                text-align: center
            }

            code, pre {
                font-family: Monaco, Andale Mono, Courier New, monospace
            }

            code {
                background-color: #fee9cc;
                color: rgba(0, 0, 0, 0.75);
                padding: 1px 3px;
                font-size: 12px;
                -webkit-border-radius: 3px;
                -moz-border-radius: 3px;
                border-radius: 3px;

                p {
                    font-family: Monaco, Andale Mono, Courier New, monospace;
                    font-size: 12px;
                }
            }

            pre {
                background-color: #fff;
                display: block;
                padding: 14px;
                margin: 0 0 18px;
                line-height: 16px;
                font-size: 12px;
                border: 1px solid #d9d9d9;
                white-space: pre-wrap;
                word-wrap: break-word;

                code {
                    background-color: #fff;
                    color: #737373;
                    font-size: 12px;
                    padding: 0
                }
            }

            sup {
                font-size: 0.83em;
                vertical-align: super;
                line-height: 0
            }

            * {
                -webkit-print-color-adjust: exact
            }

            .yunzi h3 {
                font-weight: bold;
            }

            .first {
                h3 {
                    margin-top: 0;
                }
                table{
                    td{
                        text-align: left;
                        font-weight: 400;
                        vertical-align: middle;
                        background: none;
                        font-size: 16px;
                        color: #000;
                    }

                }
                p{
                    font-size: 16px;
                }
                a{
                    color: #4183c4;
                    background: none;
                }
            }
            .demo{
                img{
                    width: 200px;
                    margin: 20px 10px 60px;
                    display: inline;
                    /*margin: 0px 10px 60px;*/
                }
                div img{
                    margin: 0 10px 60px;
                    display: inline;
                }
            }
            .download-app{
                text-align:center;
                padding:20px;
                color: #000;
                font-size: 16px;
                a {
                    background: none;
                    padding: 10px;
                    border: solid 1px;
                    border-radius: 5px;
                    margin: 10px;
                }
            }
        }

    }


    @media print {
        .markdown, .markdown code, .markdown pre code, .markdown h1, .markdown h2, .markdown h3, .markdown h4, .markdown h5, .markdown h6 {
            color: black
        }

        .markdown table, .markdown pre {
            page-break-inside: avoid
        }
    }

    @media screen and (max-width: 1680px) {
        .docs-list {
            .sidebar {
                //padding-bottom: 100px;
                width: 230px;
                margin-right: 40px;
                float: left;
                position: absolute;
                top: 40%;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/developer.vue